/**
 * Helpers for showing product names cleanly in partner (whitelabel) context.
 * We strip the hardware vendor prefix ("QIOX " or "Interact Kiosk ") when the
 * partner has configured show_vendor_names=false, so the partner's catalogue
 * looks fully neutral and branded.
 */
const VENDOR_PREFIXES = ["QIOX ", "Interact Kiosk ", "IK "];

export function productName(hw, partner) {
  const raw = hw?.name || "";
  if (!partner || partner.show_vendor_names !== false) return raw;
  for (const p of VENDOR_PREFIXES) {
    if (raw.startsWith(p)) return raw.slice(p.length);
  }
  return raw;
}

export function vendorChip(hw, partner) {
  if (partner && partner.show_vendor_names === false) return "Kiosk";
  return hw?.vendor_slug === "qiox" ? "QIOX" : "Interact Kiosk";
}
